module.exports = __webpack_public_path__ + "app/components/global-search/customers-search.view.html";